import { render, staticRenderFns } from "./strategy-allot-record-query.vue?vue&type=template&id=5eafb206"
import script from "./strategy-allot-record-query.vue?vue&type=script&lang=ts"
export * from "./strategy-allot-record-query.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports